export default __webpack_public_path__ + "static/media/aztec.61716153.png";